module.exports = __webpack_public_path__ + "img/ostali.c4e1c83a.jpg";